import { useDataClient } from "../hooks/client.hooks";
import { postRequest } from "../utils/api.utils";

export const useAdminDatasources = () => useDataClient<any>("/api/admin/datasources");

export const adminSchedule = (collectorId: string) =>
  postRequest(`/api/admin/datasources/schedule/${collectorId}`, null);
